import * as BABYLON from "babylonjs";
import { CoordUtils } from "../core/coordUtils";
import { GeoPoint } from "../core/geoPoint";

export class Anchor {
    positionOnEarth: GeoPoint;
    positionInWorld: BABYLON.Vector3;
    positionOnScreen: BABYLON.Vector2;
    visibilityPercent: number;
    data: any;

    constructor(position: GeoPoint) {
        this.positionOnEarth = position;
        this.positionInWorld = CoordUtils.geoToBabylon(position);
        this.positionOnScreen = BABYLON.Vector2.Zero();
        this.visibilityPercent = 0;
    }

    get isVisible(): boolean {
        return this.visibilityPercent > 0;
    }

    update(camTransform: BABYLON.Matrix, viewport: BABYLON.Viewport) {
        let projected = BABYLON.Vector3.Project(this.positionInWorld, BABYLON.Matrix.Identity(), camTransform, viewport);
        let x = projected.x;
        let y = projected.y;
        this.positionOnScreen = new BABYLON.Vector2(x, y);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/ui/anchor.ts